import script from "./RealtimeTutor.vue?vue&type=script&setup=true&lang=ts"
export * from "./RealtimeTutor.vue?vue&type=script&setup=true&lang=ts"

import "./RealtimeTutor.vue?vue&type=style&index=0&id=1869ad68&lang=css"

const __exports__ = script;

export default __exports__